// CRM i18n singleton.
//
// Merges shared and app-local catalogs for every supported locale.

import { createI18n, enShared, ruShared, type I18n, type NamespaceMap } from '@govard/i18n-core';

import { crmEn } from './en/crm.js';
import { getBrowserStorage, readStoredLocale, writeStoredLocale } from './locale.js';
import { featuresEn } from './en/features.js';
import { legalEn } from './en/legal.js';
import { shellEn } from './en/shell.js';
import { crmRu } from './ru/crm.js';
import { featuresRu } from './ru/features.js';
import { legalRu } from './ru/legal.js';
import { shellRu } from './ru/shell.js';

const ruNamespaces: NamespaceMap = {
  ...ruShared,
  crm: { ...crmRu, ...featuresRu, ...shellRu, ...legalRu },
};

const enNamespaces: NamespaceMap = {
  ...enShared,
  crm: { ...crmEn, ...featuresEn, ...shellEn, ...legalEn },
};

export const crmCatalogs = { ru: ruNamespaces, en: enNamespaces } as const;

const browserStorage = getBrowserStorage();

export const i18n: I18n = createI18n({
  locale: readStoredLocale(browserStorage),
  fallbackLocale: 'ru',
  catalogs: crmCatalogs,
  onMissing: 'warn',
});

i18n.subscribe(() => writeStoredLocale(browserStorage, i18n.locale));
